import React, { FC, useCallback } from 'react';
import connect from './connect';
import Form from './Form';
import { handleFormSubmitted } from './logic';
import { Props } from './types';

const ActivityFilter: FC<Props> = ({
  hash,
  pathname,
  replace,
  search,
  state,
  ...rest
}) => {
  const onSubmit = useCallback(
    handleFormSubmitted({
      hash,
      pathname,
      replace,
      search,
      state,
    }),
    [hash, pathname, replace, search],
  );

  return <Form onSubmit={onSubmit} {...rest} />;
};

export default connect(ActivityFilter);
